import { isNativeApp } from './lib/platform';
// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/

import React from 'react';
import ReactDOM from 'react-dom/client';
import WrappedRouter from './AppRouter';
import { AuthProvider } from './context/AuthContext';
import { GroupProvider } from './context/GroupContext';
import ToastProvider from './components/ToastProvider';
import ErrorBoundary from './components/ErrorBoundary';
// Register the PWA install listener before rendering routes. The browser may
// emit the event before the lazy-loaded Profile component is opened.
import './hooks/useInstallPrompt';
import './index.css';

if (isNativeApp()) {
  document.documentElement.classList.add('bb-native');
  const savedTheme = window.localStorage.getItem('theme');
  const dark = savedTheme === 'dark' || ((!savedTheme || savedTheme === 'system') && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  const fallback = document.createElement('div');
  fallback.innerHTML = `
    <div style="padding: 2rem; font-family: sans-serif; color: red; background: #fff;">
      <h2>❌ Fout: geen element met id="root" gevonden</h2>
      <p>Controleer of je <code>&lt;div id="root"&gt;&lt;/div&gt;</code> hebt in je <strong>index.html</strong>.</p>
    </div>
  `;
  document.body.appendChild(fallback);
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
        <ToastProvider>
          <AuthProvider>
            <GroupProvider>
              <WrappedRouter />
            </GroupProvider>
          </AuthProvider>
        </ToastProvider>
        </ErrorBoundary>
      </React.StrictMode>
    );
  } catch (e) {
    rootElement.innerHTML = `
      <div style="padding: 2rem; font-family: sans-serif; color: red; background: #fff;">
        <h2>❌ Fout bij renderen van React-app</h2>
        <pre>${e.message}</pre>
        <p>Bekijk <code>AuthProvider</code>, <code>GroupProvider</code> of <code>WrappedRouter</code>.</p>
      </div>
    `;
  }
}



if (!isNativeApp() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('Service worker registratie mislukt:', error);
    });
  });
}
